<template>
<!-- 底部组件 -->
  <div class="footer">
    <div class="bx">
      ©驱动中国 2005-2019 版权所有&nbsp;&nbsp;驱动中国传递价值驱动未来京ICP备11013097号广播电视节目许可证：（京）字第07618号
      京公网安备:11010802028348号高新企业认证编号：GR201811007312CMSTOP
    </div>
  </div>
</template>

<script>
import Bus from "../assets/js/eventBus.js"
export default {
  data(){
    return{

    }
  },
  mounted(){
    // Bus.$on('sendbus',res=>{
    //   //console.log(res);
    // })
  }
};
</script>

<style scoped>
.footer {
  background: #282a2d;
}
.bx {
  width: 1200px;
  height: 38px;
  color: #666;
  margin: 0 auto;
  font-size: 13px;
  line-height: 38px;
}
</style>